import { useQuery } from "@tanstack/react-query";

import API from "../../api/API";
import { Tenant } from "../../../types/GlobalInterfaces";

const useAllClouds = () => {
  const allClouds = useQuery({
    queryKey: ["allClouds"],
    queryFn: () =>
      API.getAllCloudTenants().then((data) => {
        const tenants: Array<Tenant> = data.data.data.tenants;
        return tenants;
      }),
  });

  return {
    allClouds: allClouds.data,
    allCloudsLoading: allClouds.isLoading,
    allCloudsError: allClouds.isError,
  };
};

export default useAllClouds;
